import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

const EmptyResult = ({ resetVehicleCriteria }) => {
    return (
        <div className="listing-used-car-no-result">
            <p>{LocaleService.t('NO_RESULT')}</p>
            <button className="listing-used-car-no-result__link sr-button-1" onClick={resetVehicleCriteria}>
                {LocaleService.t('NO_RESULT_BUTTON_LABEL')}
            </button>
        </div>
    );
};

EmptyResult.propTypes = {
    resetVehicleCriteria: PropTypes.func.isRequired,
};

EmptyResult.displayName = 'EmptyResult';

export default EmptyResult;
